/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { Checkbox, FormControlLabel } from '@material-ui/core';
import React from 'react';
import { NDCDetailsTextFieldComponent } from '../NDCDetailsHeaderDetailsComponent';

export const CheckboxComponent = ({
  checked = false,
  disabled = true,
  label = '',
  labelPlacement = 'end',
  onChange = () => {},
}) => {
  return (
    <FormControlLabel
      control={
        <Checkbox color="primary" checked={checked} disabled={disabled} />
      }
      label={label}
      onChange={onChange}
      labelPlacement={labelPlacement}
    />
  );
};

const CMSDrugInputContainer = ({
  cmsDrugSelectedRow,
  referenceData,
  generalSystemParameterDetails,
}) => {
  const getValueFromReferenceData = (referKey, inputValue) => {
    if (referenceData && referenceData[referKey] && inputValue) {
      const index = referenceData[referKey].findIndex(
        (item) =>
          item.codeValueID.codeDomainKey === referKey &&
          item.codeValueID.codeValue === inputValue
      );
      if (index !== -1) {
        return referenceData[referKey][index].shortDescription;
      }
      return '';
    }
    return '';
  };
  return (
    <div className="custom-fieldset row marginLeft-10">
      <div className="col-6">
        <NDCDetailsTextFieldComponent
          required={false}
          label="Drug Name Short"
          value={(cmsDrugSelectedRow && cmsDrugSelectedRow.drugNameShort) || ''}
        />
      </div>
      <div className="col-6">
        <NDCDetailsTextFieldComponent
          required={false}
          label="FDA Thera Equivalent"
          value={
            (cmsDrugSelectedRow && cmsDrugSelectedRow.fdaTheraEquivCd) || ''
          }
        />
      </div>
      <div className="col-6">
        <NDCDetailsTextFieldComponent
          required={false}
          label="Drug Category"
          value={
            (cmsDrugSelectedRow &&
              getValueFromReferenceData(
                'DRUG_CAT_CD',
                cmsDrugSelectedRow.drugCatCd
              )) ||
            ''
          }
        />
      </div>
      <div className="col-6">
        <NDCDetailsTextFieldComponent
          required={false}
          label="Drug Type"
          value={
            (cmsDrugSelectedRow &&
              getValueFromReferenceData(
                'DRUG_TYPE_CD',
                cmsDrugSelectedRow.drugTypeCd
              )) ||
            ''
          }
        />
      </div>
      <div className="col-6">
        <NDCDetailsTextFieldComponent
          required={false}
          label="Unit Type"
          value={
            (cmsDrugSelectedRow &&
              getValueFromReferenceData(
                'UNIT_TYPE_CD',
                cmsDrugSelectedRow.unitTypeCd
              )) ||
            ''
          }
        />
      </div>
      <div className="col-6">
        <NDCDetailsTextFieldComponent
          required={false}
          label="URA Type"
          value={
            (cmsDrugSelectedRow &&
              getValueFromReferenceData(
                'URA_TYPE_CD',
                cmsDrugSelectedRow.uraTypeCd
              )) ||
            ''
          }
        />
      </div>

     {generalSystemParameterDetails?.[0]?.hideCmsUraInd !== 1 && (
        <div className="col-6">
          <NDCDetailsTextFieldComponent
            required={false}
            label="Unit Rebate Amount"
            value={
            cmsDrugSelectedRow?.unitRebateAmt
              ? Number(cmsDrugSelectedRow.unitRebateAmt).toFixed(6)
              : '0.000000'
          }
          />
        </div>
       )}
      <div className="col-6">
        <NDCDetailsTextFieldComponent
          required={false}
          label="Unit Per Package Size"
          value={
            (cmsDrugSelectedRow && cmsDrugSelectedRow.unitPerPackageSize) || ''
          }
        />
      </div>

      <div className="col-6">
        <div className="form-wrapper vertical-wrapper">
          <div className="mui-custom-form no-margin min-md">
            <div className="sub-radio text-black sub-label">
              <CheckboxComponent
                label="Pediatric"
                checked={
                  !!(
                    cmsDrugSelectedRow && cmsDrugSelectedRow.pediatricInd === 1
                  )
                }
                labelPlacement="end"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col-6">
        <div className="form-wrapper vertical-wrapper">
          <div className="mui-custom-form no-margin min-md">
            <div className="sub-radio text-black sub-label">
              <CheckboxComponent
                label="Clotting Factor"
                checked={
                  !!(
                    cmsDrugSelectedRow &&
                    cmsDrugSelectedRow.clottingFactorInd === 1
                  )
                }
                labelPlacement="end"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="col-6">
        <NDCDetailsTextFieldComponent
          required={false}
          className="with-select"
          label="Line Extension Drug"
          value={
            (cmsDrugSelectedRow && cmsDrugSelectedRow.lineExtDrugInd) || ''
          }
          select
          selectReset={false}
          selectData={[
            { label: 'Yes', value: 'Y' },
            { label: 'No', value: 'N' },
          ]}
        />
      </div>
      <div className="col-6">
        <NDCDetailsTextFieldComponent
          required={false}
          label="Market Entered Date"
          value={
            (cmsDrugSelectedRow && cmsDrugSelectedRow.marketEnteredDt) || ''
          }
        />
      </div>
      <div className="col-6">
        <NDCDetailsTextFieldComponent
          required={false}
          label="FDA Approval Date"
          value={(cmsDrugSelectedRow && cmsDrugSelectedRow.fdaApprovalDt) || ''}
        />
      </div>
      <div className="col-6">
        <NDCDetailsTextFieldComponent
          required={false}
          label="FDA Application"
          value={
            (cmsDrugSelectedRow && cmsDrugSelectedRow.fdaApplication) || ''
          }
        />
      </div>
      <div className="col-6">
        <NDCDetailsTextFieldComponent
          required={false}
          label="Reactivation Date"
          value={
            (cmsDrugSelectedRow && cmsDrugSelectedRow.reactivationDt) || ''
          }
        />
      </div>
      <div className="col-6">
        <NDCDetailsTextFieldComponent
          required={false}
          label="Termination Reported Date"
          value={
            (cmsDrugSelectedRow && cmsDrugSelectedRow.terminationReportedDt) ||
            ''
          }
        />
      </div>
      <div className="col-6">
        <NDCDetailsTextFieldComponent
          required={false}
          label="Termination Date"
          value={(cmsDrugSelectedRow && cmsDrugSelectedRow.terminationDt) || ''}
        />
      </div>
    </div>
  );
};

export default CMSDrugInputContainer;
